// @core/api/endpoints/team/assign_team_role.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AssignTeamRoleRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Assign role to team member
 * Assigns a specific role to a team member. Multiple roles can be assigned to the same member.
 */
export async function AssignTeamRole(
  team_id: string,
  data: AssignTeamRoleRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/roles/assign`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
